import React, { PureComponent } from 'react';
import format from 'date-fns/format';

import './ShortOrderSummary.scss';

import { formatCurrency } from 'formatters';
import { getEstimatedDeliveryDate } from 'helpers';

interface OwnProps {
    total: number;
    leadTime?: number;
    eca: number | null;
    deposit: number;
    monthlyPayment: number;
    term: number;
    percentage: number;
    hasQuickstockItem: boolean;
}

const DATE_FORMAT = 'MMMM d, yyyy';

class ShortOrderSummary extends PureComponent<OwnProps> {
    render() {
        const { total, leadTime, eca, deposit, monthlyPayment, term, percentage, hasQuickstockItem } = this.props;
        const notBefore = format(eca ? new Date(eca) : new Date(), DATE_FORMAT);

        return (
            <div className='short-summary-panel'>
                <div className='short-summary-panel__total'>
                    Total: {formatCurrency(total)}
                </div>
                <div className='short-summary-panel__delivery'>
                    <span>
                        <i className='sa sa-delivery-fast truck'></i>
                        {leadTime ? getEstimatedDeliveryDate(leadTime, hasQuickstockItem) : getEstimatedDeliveryDate(NaN, hasQuickstockItem)}
                    </span>
                    <span>Not before: {notBefore}</span>
                </div>
                <div className='short-summary-panel__edit'>
                    <a className='short-summary-panel__edit__link' href='/basket'>
                        {formatCurrency(deposit)} today
                        then {formatCurrency(monthlyPayment)} x {term} months
                        at {percentage}% APR
                    </a>
                </div>
            </div>
        );
    }
}

export default ShortOrderSummary;